
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { cropTextSmart, random } from 'SharedDir/utils/helpers';

import ServiceTypeBadge from 'src/modules/Services/components/ServiceTypeBadge.vue';

export default defineComponent({
  name: 'ServiceItem',
  components: { ServiceTypeBadge, SBtn, SIcon },
  props: {
    service: {
      type: Object,
      required: true,
    },
    iconNumber: {
      type: Number,
      required: false,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const router = useRouter();

    const iconName = [
      'user',
      'saving',
      'money',
      'home1',
      'home2',
      'heart',
      'education',
      'culture2',
      'culture1',
    ];

    const getServiceName = computed(() => {
      return props.service?.name ? cropTextSmart(props.service.name, 196) : '';
    });

    const getDescription = computed(() => {
      return props.service?.shortDescription
        ? cropTextSmart(props.service.shortDescription, 256)
        : '';
    });

    const getIconName = () => {
      if (iconName.length > props.iconNumber) {
        return `custom:${iconName[props.iconNumber]}`;
      }
      return `custom:${iconName[random([0, iconName.length - 1])]}`;
    };

    async function goToService() {
      await router.push({
        name: 'service-view',
        params: {
          serviceId: (props.service.id as number).toString(),
        },
      });
    }

    const { isMobile } = useDeviceSize();

    return { props, getServiceName, getDescription, goToService, getIconName, isMobile };
  },
});
